module.exports = __webpack_public_path__ + "static/OIC-01.91bfe875.svg";